export * from './validSwissPostalCode'
